import React, { FunctionComponent } from 'react';
import { Grid, Typography } from '@rbx/ui';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import ColoredMethod from './ColoredMethod';
import useOperationNavItemStyles from './OperationNavItem.styles';

export interface OperationNavItemProps {
  method: OpenAPI.HttpMethod;
  title: string;
}

const OperationNavItem: FunctionComponent<React.PropsWithChildren<OperationNavItemProps>> = ({
  method,
  title,
}) => {
  const { classes } = useOperationNavItemStyles();

  return (
    <Grid container wrap='nowrap' alignItems='flex-start'>
      <Grid classes={{ root: classes.method }} item>
        <ColoredMethod method={method} />
      </Grid>
      <Typography classes={{ root: classes.title }} variant='body1'>
        {title}
      </Typography>
    </Grid>
  );
};

export default OperationNavItem;
